import api from "../config/api";

const search = query => {
  return api.post("/zipcode/search", {
    query
  });
};

export { search };
